<template>
    <div class="main-body">
        <div class="header" >预交金列表</div>
        <div class="out">
            <div class="search2">

                <el-button type="primary" size="mini" @click.native="toggleModalAdd">充值</el-button>

                <div style="float:right">
                    <el-input size="mini" placeholder="请输入老人姓名" v-model="elderlyName" clearable style="width:200px;margin-right:10px"></el-input>
<!--                    <el-select v-model="rechargeType" size="mini" placeholder="请选择充值类型" style="width:200px;margin-right:10px">-->
<!--                        <el-option-->
<!--                                v-for="item in typeValue"-->
<!--                                :key="item[0]"-->
<!--                                :label="item[1]"-->
<!--                                :value="item[0]">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
                    <el-select v-model="type" size="mini" placeholder="请选择" style="margin-right: 10px;">
                        <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>

                  <el-date-picker size="mini" style="margin-right: 10px;width:200px;" title="起止时间"
                                  v-model="startEndTime"
                                  type="daterange"
                                  value-format="yyyy-MM-dd"
                                  format="yyyy-MM-dd"
                                  range-separator="至"
                                  start-placeholder="开始时间"
                                  end-placeholder="结束时间">
                  </el-date-picker>

                    <el-button size="mini" style="float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
                </div>

                <div style="clear: both;"></div>

            </div>

            <el-table class="table" size="mini" :data="tableData" :height="th" border style="width: 100%;">
                <el-table-column label="老人姓名" prop="elderlyDTO.name" width="100" fixed></el-table-column>
                <el-table-column label="手机号" prop="elderlyDTO.phone" width="120"></el-table-column>
                <el-table-column label="身份证号" prop="elderlyDTO.idCard" width="180"></el-table-column>

              <el-table-column prop="money" label="充值" width="100"></el-table-column>
              <el-table-column prop="remarks" label="备注" width="200" ></el-table-column>
              <el-table-column prop="type" label="类型"  width="100">
                    <template slot-scope="scope">
                        <span class="a" v-if="scope.row.type==1">充值</span>
                        <span class="b" v-if="scope.row.type==2">使用</span>
                      <span class="b" v-if="scope.row.type==3">转余额</span>
                    </template>
                </el-table-column>
                <el-table-column prop="rechargeType" label="收款类型" width="100">
                    <template slot-scope="scope">
                        <span v-if="scope.row.rechargeType==1">现金</span>
                        <span v-if="scope.row.rechargeType==2">支付宝</span>
                        <span v-if="scope.row.rechargeType==3">微信</span>
                        <span v-if="scope.row.rechargeType==4">刷卡</span>
                      <span v-if="scope.row.rechargeType==5">补贴</span>
                      <span v-if="scope.row.rechargeType==6">转账</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" :formatter="formatterTime" width="180" label="创建时间"></el-table-column>


              <el-table-column prop="advance" label="总预交金" width="150"></el-table-column>

              <el-table-column label="地区" prop="elderlyDTO.areaName" width="280"></el-table-column>
              <el-table-column label="详细地址" prop="elderlyDTO.homeAddress" width="380"></el-table-column>

              <el-table-column label="操作" width="120" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="mini" @click.native.prevent="changeBalance(scope.row)">转余额</el-button>
                  <el-button type="text" size="mini" @click="handlePrint(scope.$index, scope.row)">打印</el-button>
                </template>
              </el-table-column>


            </el-table>

            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>


        </div>

        <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>



      <el-dialog title='充值凭证' :visible.sync="voucherDialog"
                 :modal-append-to-body='false'
                 width='800px' center top='10vh'
                 :close-on-click-modal='false'>

        <div id="printTest2" v-if="successInfo!=null">
          <div style="padding: 20px;">
            <div style="text-align: center;font-size: 25px;">
              <div>收款收据</div>
            </div>
            <div style="padding: 10px 0px;">
              <div style="float: left;">收款单位：{{insName}}</div>
              <div style="float: right;">日期：{{formatterTime2(successInfo.createTime).substring(0,16)}}</div>
              <div style="clear:both;"></div>
            </div>
            <div>
              <table style="width: 100%;height:200px;border: 1px solid #ddd;padding: 0px;border-collapse:collapse;">
                <tr style="height: 50px;">
                  <th style="width: 20%">收费项目名称</th>
                  <th style="width: 20%">收款金额</th>
                  <th style="width: 20%">交款方式</th>
                  <th style="width: 40%">备注</th>
                </tr>
                <tr align="center" style="height: 50px;">
                  <td>预交金充值</td>
                  <td>{{successInfo.money}}</td>
                  <td>{{getType(successInfo.rechargeType)}}</td>
                  <td>{{successInfo.remarks}}</td>
                </tr>
                <tr style="height: 50px">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr style="height: 50px">
                  <td align="right">大写金额：</td>
                  <td colspan="2">{{convertCurrency(successInfo.money)}}</td>
                  <td></td>
                </tr>
              </table>

            </div>
            <div style="padding: 10px 0px;">
              <div style="float: left;">收款单位（盖章）：</div>
              <div style="float: right;">交款人：{{successInfo.elderlyName}}</div>
              <div style="clear:both;"></div>
            </div>

          </div>
        </div>

        <div style="text-align: center">
          <el-button type="info" v-print="'#printTest2'">打印</el-button>
        </div>

      </el-dialog>


    </div>
</template>

<script>

    import {timeStr,timefilters,getBeforeDate} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import Add from "./Add";
    import {getStaffCode, getStaffDTO} from "@/utils/auth";


    export default {
        name: "Role",
        data(){
            return{
                loading:true,

              startTime:getBeforeDate(-30),
              endTime:getBeforeDate(0),

              startEndTime:[],


                menuButtonList:null,
                disabledAdd:true,
                disabledCut:true,
                showModalAdd:false,
                showModalEmploy:false,
                batchDialog:false,
                tableData:null,
                elderlyName:null,

                type:-1,
                options: [{
                value: -1,
                label: '全部'
                }, {
                value: 1,
                label: '充值'
                }, {
                value: 2,
                label: '使用'
                }],

                rechargeType:-1,
              typeValue:[
                {value:1,label:"现金"},
                {value:2,label:"支付宝"},
                {value:3,label:"微信"},
                {value:4,label:"刷卡"},
                {value:5,label:"补贴"},
                {value:6,label:"转账"}
              ],

                datetimerangeValue:[],

                idNumber:'',
                phone:'',
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                name:'',


              voucherDialog:false,
              successInfo:null,
              insName:getStaffDTO().institutionDTO.userDTO.name,

            }
        },
        components:{
            Add,
        },
        created(){

          const end = new Date();
          const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
          this.startEndTime = [start, end];

            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{

            formatterTime(row, column, cellValue) {
                return timefilters(cellValue)
            },
          formatterTime2(cellValue) {
            return timefilters(cellValue)
          },
            toggleModalAdd:function(){
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            toggleModalEmploy:function(){
                this.showModalEmploy = !this.showModalEmploy;
                this.$refs.myEmploy.init();
            },
            closeEmploy:function(){
                this.showModalEmploy = !this.showModalEmploy;
            },
            closeAdd:function(){
                this.showModalAdd = !this.showModalAdd;
            },
            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getList(){
                this.loading = true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"AdvanceRecord/Page",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        elderlyName:this.elderlyName,
                        type:this.type,
                        rechargeType:this.rechargeType,
                      startTime: timefilters(this.startEndTime[0]),
                      endTime: timefilters(this.startEndTime[1]),
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    this.loading = false;
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },

          changeBalance(row){

            if(row.advance==0){
              this.$message.error('此老人无预交金，无法转入余额！')
              return;
            }

            this.$confirm('是否将('+row.elderlyDTO.name+')的('+row.advance+')元预交金转入余额?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {

              this.$axios({
                method: 'post',
                url: this.$shopUrl+"AdvanceRecord/ChangeToBalance",
                data: {
                  timeStr:timeStr,
                  sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                  staffCode: getStaffCode(),
                  elderlyCode:row.elderlyCode,
                }
              }).then(
                  (response) => {
                    if (response.data.error == 0) {
                      this.$message.success('转入余额成功！')
                      this.$emit('getList')
                      this.getList();
                    }else if(response.data.error == 1){
                      this.$message({type: 'info', message: response.data.message});
                    }
                  }
              )


            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
            });
          },


          getType(type){
            let data=''
            this.typeValue.forEach(element => {
              if(element.value==type){
                data=element.label
              }
            });
            return data
          },
          convertCurrency(money) {
            //汉字的数字
            var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖');
            //基本单位
            var cnIntRadice = new Array('', '拾', '佰', '仟');
            //对应整数部分扩展单位
            var cnIntUnits = new Array('', '万', '亿', '兆');
            //对应小数部分单位
            var cnDecUnits = new Array('角', '分', '毫', '厘');
            //整数金额时后面跟的字符
            var cnInteger = '整';
            //整型完以后的单位
            var cnIntLast = '元';
            //最大处理的数字
            var maxNum = 999999999999999.9999;
            //金额整数部分
            var integerNum;
            //金额小数部分
            var decimalNum;
            //输出的中文金额字符串
            var chineseStr = '';
            //分离金额后用的数组，预定义
            var parts;
            // 传入的参数为空情况
            if(money == '') {
              return '';
            }
            money = parseFloat(money)
            if(money >= maxNum){
              return ''
            }
            // 传入的参数为0情况
            if(money == 0) {
              chineseStr = cnNums[0] + cnIntLast + cnInteger;
              return chineseStr
            }
            // 转为字符串
            money = money.toString();
            // indexOf 检测某字符在字符串中首次出现的位置 返回索引值（从0 开始） -1 代表无
            if(money.indexOf('.') == -1){
              integerNum = money;
              decimalNum = ''
            }else{
              parts = money.split('.');
              integerNum = parts[0];
              decimalNum = parts[1].substr(0,4);
            }
            //转换整数部分
            if(parseInt(integerNum,10) > 0){
              let zeroCount  = 0;
              let IntLen = integerNum.length
              for(let i = 0; i < IntLen; i++){
                let n = integerNum.substr(i,1);
                let p = IntLen - i - 1;
                let q = p / 4;
                let m = p % 4;
                if( n == '0'){
                  zeroCount ++ ;
                }else{
                  if(zeroCount > 0){
                    chineseStr += cnNums[0]
                  }
                  zeroCount = 0;
                  chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
                }
                if(m == 0 && zeroCount < 4){
                  chineseStr += cnIntUnits[q];
                }
              }
              // 最后+ 元
              chineseStr += cnIntLast;
            }
            // 转换小数部分
            if(decimalNum != ''){
              let decLen = decimalNum.length;
              for(let i = 0; i <decLen; i++){
                let n = decimalNum.substr(i,1);
                if(n != '0'){
                  chineseStr += cnNums[Number(n)] + cnDecUnits[i]
                }
              }
            }
            if(chineseStr == ''){
              chineseStr += cnNums[0] + cnIntLast + cnInteger;
            }else if(decimalNum == ''){
              chineseStr += cnInteger;
            }

            return chineseStr
          },
          closeDialog(){
            //this.getList();
          },
          handlePrint(index,row){

            let e = {elderlyName:row.elderlyDTO.name,createTime:row.createTime,
              money:row.money,
              rechargeType:row.rechargeType,remarks:row.remarks};

            this.voucherDialog = true;
            this.successInfo = e;
          },



        }
    }
</script>

<style lang="scss" scoped>
    .a{
        color: blue;
    }
    .b{
        color: red;
    }

</style>
